<div class="d-flex flex-column w-100 h-100" style="max-height: 80vh; overflow: hidden;">
    <!-- Close Button -->
    <div class="w-100 d-flex justify-content-end p-2 sticky-top" >
      <button class="customPreActivatedButtons1 p-1"  style="background-color: #000000;" (click)="close()">
        <mat-icon >close</mat-icon>
      </button>
    </div>
  
    <!-- Chat Container -->
    <div class="w-100 h-100">
      <mat-dialog-content class="mat-typography p-4 chat-container text-start" style="width: 40vw;" #chatContainer>
        @for (comment of comments; track comment.comment) {
          <!-- Date Separator -->
          <div class="d-flex align-items-center my-4" *ngIf="isNewDate(comment.createTime)">
            <hr class="chatDateSaperator">
            <span class="chatDateText">{{ comment.createTime | date: 'EEE, dd MMM yyyy' }}</span>
            <hr class="chatDateSaperator">
          </div>
  
          <!-- Comment Card -->
          <mat-card-content [ngStyle]="{ 'justify-items': comment.alignment }">
            <mat-card appearance="outlined" class="mb-2 shadow-sm"
                      style="border-radius: 8px; border: 1px solid #63D3B6;"
                      [ngStyle]="{ 'width': getWidth(comment.imageContents), 'background-color': getColorByUser(comment.userId) }">
          
              <div class="ps-2 pt-1" style="font-size: small; line-height: 12px; color: #008A70; font-weight: 500;"
                   *ngIf="dataService.userId != comment.userId">
                {{ comment.userId }}
              </div>
          
              <img class="p-2" style="cursor: pointer; width: 300px; height: auto;" *ngIf="comment.imageContents != ''"
                   src="data:image/*;base64,{{comment.imageContents}}" (click)="previewImage(comment.imageContents)" />
          
              <div class="container p-1 px-2">
                <div class="row lh-sm">
                  <div class="col" style="font-size: medium; white-space: pre-wrap;">
                    <p class="m-0" style="color: #205567; white-space: normal;">{{ comment.comment }}</p>
                  </div>
                  <div class="mt-2">
                    <!-- VOICE MESSAGE -->
                    <audio
                      style="width: 100%;"
                      *ngIf="comment.audioContents"
                      controls
                      [src]="'data:audio/webm;base64,' + comment.audioContents">
                    </audio>
                  </div>
                </div>
                <div class="row text-end lh-sm pt-1">
                  <div class="col" style="font-size: x-small; color: #205567;">
                    <p class="m-0">{{ comment.createTime | date: 'shortTime' }}</p>
                  </div>
                </div>
              </div>
            </mat-card>
          
            <!-- Translate button below with spacing -->
            <div class="d-flex justify-content-end mt-2 mb-4">

             

<div class="translate-container">

  <!-- Translate button -->
  <button
    mat-icon-button
    [matMenuTriggerFor]="langMenu"
    matTooltip="Translate Options"
       
  >
    <mat-icon>translate</mat-icon>
  </button>
  <mat-menu #langMenu="matMenu" class="custom-menu-panel">
    <button mat-menu-item (click)="translateComment(comment,'en')">
      English
    </button>

    <button mat-menu-item (click)="translateComment(comment,'de')">
      German
      
    </button>

    <button
       *ngIf="comment.source === 'translated'"
       mat-menu-item
      (click)="translateComment(comment,'original')"
    >
      Show Original
    </button>
  </mat-menu>

  <!-- Eye / Translate toggle button
  <button
    mat-icon-button
    [matMenuTriggerFor]="langMenuEyes"
    matTooltip="{{ comment.source === 'translated' ? 'Show Original' : 'Translate' }}"
    matTooltipPosition="above"
     *ngIf="comment.source === 'translated'"
  >
    <mat-icon>
      {{ comment.source === 'translated' ? 'visibility' : 'translate' }}
    </mat-icon>
  </button>

  <mat-menu #langMenuEyes="matMenu" class="custom-menu-panel">
    <button mat-menu-item (click)="translateComment(comment,'en')">
      English
    </button>

    <button mat-menu-item (click)="translateComment(comment,'de')">
      German
    </button>

    <button
      mat-menu-item
      *ngIf="!comment.isTranslated"
      (click)="translateComment(comment,'original')"
    >
      Show Original
    </button>
  </mat-menu> -->

</div>

              </div>
            
            {{scrollToBottom()}}
          </mat-card-content>
          
        }
      </mat-dialog-content>
    </div>
  
    <!-- Message Input -->
    <div class="w-100">
      <mat-dialog-actions class="pt-0" align="start">
        <div class="w-100 d-flex align-items-end">
          <div class="d-flex align-items-end justify-content-center w-100 rounded-5 gap-2 shadow-sm" style="background: #f9f9f9;">
            <button class="customPreActivatedButtons1 p-2" (click)="customFile.click()">
              <mat-icon>add</mat-icon>
            </button>
            <input hidden (change)="addFileDetails($event)" #customFile type="file" id="customFile">
            <textarea [disabled]="isRecording" class="border-0 align-self-center disabled:bg-gray-100" rows="1" placeholder="Type your message..." [(ngModel)]="comment"
                      (input)="autoGrowTextArea($event)"
                      style="width: 100%; max-height: 200px; overflow: hidden; resize: none; outline: none; background: none; color: #205567;"></textarea>
            <div class="d-flex align-items-center justify-content-center gap-1">
              <button class="customPreActivatedButtons1 d-flex align-items-center p-2"
                      matTooltipPosition="above" matTooltip="Send Comment" (click)="postComment($event)">
                <mat-icon style="color: #f9f9f9;">send</mat-icon>
              </button>
              <button class="customPreActivatedButtons1 p-2" (click)="toggleRecording()" matTooltipPosition="above" matTooltip="{{ isRecording ? 'Stop Recording' : 'Record Voice Comment' }}">
                <mat-icon *ngIf="!isProcessing; else loading">
                  {{ isRecording ? 'stop' : 'keyboard_voice' }}
                </mat-icon>

                <ng-template #loading>
                  <mat-spinner class="text-[#ffffff]" diameter="24"></mat-spinner>
                </ng-template>
              </button>
            </div>
          </div>
        </div>
      </mat-dialog-actions>
    </div>
  </div>
  
  <!-- Spinner -->
  <div class="spinner-overlay" *ngIf="dataService.progressBarActiveForSlider">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
  